import { Badge, Text } from '@usealloy/component-library';
import styled, { css } from 'styled-components';

interface StyledRuleEditorContainerStyleProps {
  isFocused: boolean;
  isFaded: boolean;
  isInteractionDisabled: boolean;
}

export const StyledRuleEditorContainer = styled.div<StyledRuleEditorContainerStyleProps>`
  border: 1px solid var(--cl-gray-300);
  border-radius: var(--cl-radius-2);
  overflow: hidden;

  ${p => p.isFocused && css`
    border: 1px solid var(--cl-juicyBlue-500);
    box-shadow:0px 0px 0px 4px color-mix(in srgb, var(--cl-juicyBlue-100) 80%, transparent);
  `}

  ${p => p.isFaded && css`
    opacity: 0.6;
  `}

  ${p => p.isInteractionDisabled && css`
    pointer-events: none;
  `}
`;


export const StyledRuleHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: var(--cl-space-4);
  border-bottom: 1px solid var(--cl-gray-300);
  align-items: center;
`;

export const StyledBadge = styled(Badge)`
  &&& {
    height: 32px;
    background-color: var(--cl-juicyBlue-50);
  }
`;

export const StyledSetOutcomeBadge = styled(Badge)`
  &&& {
    height: 32px;
    background-color: var(--cl-gray-300);
    gap: var(--cl-space-2);
  }
`;

export const StyledActionControlsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: var(--cl-space-4);
  border-top: 1px solid var(--cl-gray-300);

  & button:first-child {
    margin-right: 1em;
  }
`;

export const StyledEditorContainer = styled.div<{
  rulesExist: boolean;
  isPreviewAction: boolean;
}>`
  ${({ rulesExist, isPreviewAction }) => (!rulesExist ? css`
    padding: var(--cl-space-4);
  ` : !isPreviewAction && css`
    position: relative;
    &:before {
      display: block;
      content: '';
      width: 26px;
      position: absolute;
      background: var(--cl-gray-100);
      height: 100%;
    }
  `)}
`;

export const StyledDefaultEditorText = styled(Text)`
  &&& {
    font-family: var(--cl-font-family-mono);
    font-size: var(--cl-font-size-2);
    line-height: 1.6;
  }
`;

export const StyledDecisioningWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0.25rem;
  margin-left: 2.3rem;
  width: fit-content;
  gap: var(--cl-space-1);
`;

export const StyledDecisioningCopyWrapper = styled.span`
  font-family: var(--cl-font-family-mono);
  font-size: var(--cl-font-size-2);
  line-height: 1.5rem;
`;
